import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,{attrs:{"items":_vm.types,"label":_vm.$t('Product type'),"outlined":""},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}})}
var staticRenderFns = []

export { render, staticRenderFns }